import { Injectable } from '@angular/core';
import { AlertController, ToastController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
@Injectable()
export class ViewProvider {

  constructor(public alertCtrl: AlertController,public toastCtrl: ToastController, private inBrowser:InAppBrowser) {
  }
 
  public showError(text) {
    let alert = this.alertCtrl.create({
      title: 'Falha',
      subTitle: text,
      buttons: ['OK']
    });
    alert.present();
  }

  public showMessage(text, callback = () => {}){
    const alert = this.alertCtrl.create({
      title: 'Info',
      subTitle: text,
      buttons: [{
        text:'Ok',
        handler:callback
      }]
    });

    alert.present();
  }


  showConfirm(texto, confirm_function) {
    let confirm = this.alertCtrl.create({
      title: "Pergunta",
      subTitle: texto,
      buttons: [
        {
          text: 'Sim',
          handler: confirm_function
        },
        {
          text: 'Não'//,
        }
      ]
    });
    confirm.present();
  }

  showInput(titulo, texto, confirm_function) {
    let confirm = this.alertCtrl.create({
    title: titulo,
    subTitle: texto,
    inputs: [
      {
        name: 'informacao',
      }
      ,
      // {
      //   name: 'password',
      //   placeholder: 'Password',
      //   type: 'password'
      // }
    ],
    buttons: [
      {
        text: 'Cancelar',
        role: 'cancel',
        handler: data => {
          //console.log('Cancel clicked');
        }
      },
      {
        text: 'Confirmar',
        handler: confirm_function
      }
    ]
    });
    confirm.present();
  }


  abrirLink(link, target="_system"){
    this.inBrowser.create(link, target);
  }

  toast(texto, tempo = 2000){
    let toast = this.toastCtrl.create({
      position: "bottom",
      message: texto,
      duration: tempo
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/view/view.ts